import { css } from '@emotion/react'
import { Button, Flow, Icon, Theme, Tooltip, useTheme } from 'bold-ui'
import { SIDE_MENU_Z_INDEX } from 'components/layout/SideMenu/SideMenuNav'
import { ReactNode, useState } from 'react'
import { generatePath, useHistory, useRouteMatch } from 'react-router'

import { MAPA_SIDEBAR_NAV_ITEM_ROUTE, MapaSidebarNavItemEnum } from '../model-territorioMapa'
import { parseMapaSidebarNavItem } from '../utils-territorioMapa'
import { MapaSidebarNavItem } from './MapaSidebarNavItem'

interface MapaViewSidebarProps {
  panels: Record<MapaSidebarNavItemEnum, ReactNode>
}

export function MapaViewSidebar(props: Readonly<MapaViewSidebarProps>) {
  const { panels } = props

  const match = useRouteMatch<{ mapaSidebarNavItem?: string }>()
  const history = useHistory()
  const selectedNavItem = parseMapaSidebarNavItem(match.params.mapaSidebarNavItem)

  const [isSidebarOpen, setIsSidebarOpen] = useState(true)

  const theme = useTheme()
  const styles = createStyles(theme)

  const handleSelectNavItem = (navItem: MapaSidebarNavItemEnum) => {
    history.push(generatePath(match.path, { mapaSidebarNavItem: MAPA_SIDEBAR_NAV_ITEM_ROUTE[navItem] }))
  }

  const toggleSidebarOpen = () => {
    setIsSidebarOpen((prev) => !prev)
  }

  return (
    <Flow direction='horizontal' gap={0} style={styles.sidebar}>
      <Flow direction='vertical' justifyItems='center' style={styles.sidebarNav}>
        <Flow direction='vertical' gap={0} style={styles.sidebarNavFlow}>
          {Object.values(MapaSidebarNavItemEnum).map((navItem) => (
            <MapaSidebarNavItem
              key={navItem}
              navItem={navItem}
              selectedNavItem={selectedNavItem}
              onSelect={handleSelectNavItem}
            />
          ))}
        </Flow>
        <Tooltip text={isSidebarOpen ? 'Ocultar lateral' : 'Exibir lateral'}>
          <Button skin='ghost' size='small' onClick={toggleSidebarOpen} style={styles.sidebarNavButton}>
            <Icon icon={isSidebarOpen ? 'arrowLeft' : 'arrowRight'} />
          </Button>
        </Tooltip>
      </Flow>
      {isSidebarOpen && panels[selectedNavItem]}
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  sidebar: css`
    box-shadow: 2px 0 4px -10px rgba(0, 0, 0, 0.2), 1px 0 10px -10px rgba(0, 0, 0, 0.12),
      4px 0 5px -3px rgba(0, 0, 0, 0.14);
    z-index: ${SIDE_MENU_Z_INDEX - 1};
  `,
  sidebarNav: css`
    width: 4rem;
    border-right: 1px solid ${theme.pallete.divider};
    grid-template-rows: 1fr auto;
    padding-bottom: 1rem;
  `,
  sidebarNavFlow: css`
    width: 100%;
  `,
  sidebarNavButton: css`
    padding-left: 0;
    padding-right: 0;
    width: 2rem;
  `,
})
